/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Employee/view.blocks to change it.
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'



/** @type {import('Simple/types.js').View} */
export default function Employee({
  children,
  viewPath = "/App/ChooseUser/Users/Content/User/Tag/Employee"
  
}) {
  return (<React.Fragment
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text="Employee"
/>
)}
</TysiaTag>
{children}
</React.Fragment>)
}